<template lang="pug">
  .auth-form__wrap
    .auth-form
      .auth-form__logo
      h1.auth-form__caption.text-center Вход в систему
      ValidationObserver(v-slot="{ handleSubmit }")
        form(method='POST' @submit.prevent="handleSubmit(login)")
          ValidationProvider.auth-form__row(
            rules="required|email"
            mode="lazy"
            v-slot="{ errors }"
          )
            input#email.form-control(
              type='email',
              placeholder='Email',
              autofocus='',
              v-model='email'
              v-bind:class="{ error: errors[0] }"
            )
            span(v-if="errors[0]").auth-form__error {{ errors[0] }}
          ValidationProvider.auth-form__row(
            rules="required"
            mode="lazy"
            v-slot="{ errors }"
          )
            input#password.form-control(
              type='password',
              placeholder='Пароль',
              v-model='password'
              v-bind:class="{ error: errors[0] }"
            )
            span(v-if="errors[0]").auth-form__error {{ errors[0] }}
          button.auth-form__submit(type="submit") Войти
          .auth-form__footer
            a.auth-form__label.auth-form__link(:href="registerUrl") Регистрация
            span.spacer /
            router-link.auth-form__label.auth-form__link(to="/restore") Забыли пароль?

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { mapState } from 'vuex';
import config from '@/config';

extend('email', {
  ...email,
  message: 'Email указан не верно'
});

extend('required', {
  ...required,
  message: 'Обязательно'
});

export default {
  data() {
    return {
      email: '',
      password: ''
    };
  },

  computed: {
    registerUrl: () => config.urls.registration,
    ...mapState({
      userEntryUrl: state => state.user.entryUrl
    })
  },

  methods: {
    login() {
      const { email, password } = this;

      if (email.trim().length < 1 || password.trim().length < 1) {
        this.flashError('Заполните все поля');
        return;
      }

      this.$store
        .dispatch('login', { email, password })
        .then(() => {
          if (this.userEntryUrl !== null) {
            const entryRoute = this.$router.resolve(this.userEntryUrl).resolved;
            if (entryRoute.path !== this.$route.path) {
              this.$router.push(entryRoute.path);
            } else {
              this.$router.push({ name: 'home' });
            }
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.flashError('Неправильный логин или пароль');
          } else {
            this.flashError('Произошла ошибка при попытке входа');
          }
        });
    }
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
};
</script>

<style lang="scss" src="../Auth.scss"></style>
